import { render } from "./rate_details.vue?vue&type=template&id=4acd78e0&scoped=true"
import script from "./rate_details.vue?vue&type=script&lang=js"
export * from "./rate_details.vue?vue&type=script&lang=js"

import "./rate_details.vue?vue&type=style&index=0&id=4acd78e0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acd78e0"]])

export default __exports__